import main from './index.vue'
// 首页
import sy from '@/views/sy/pages/index.vue'
// 首页的公告
import gg from '@/views/sy/pages/gg.vue'
// 首页的岗位
import gw from '@/views/sy/pages/gw.vue'
// 首页的更多公告
import gdgg from '@/views/sy/pages/gdgg.vue'
// 找回密码
import zhmm from '@/views/sy/pages/zhmm.vue'
// 招考职位
import zkzw from '@/views/zkzw/router.js'
// 个人中心
import grzx from '@/views/grzx/router.js'
// 我的简历
import wdjl from '@/views/wdjl/router.js'
// 问题解答
import wtjd from '@/views/wtjd/router.js'


const router={
  path: '/',
  component: main,
  redirect: '/sy',
  children: [
    {
      path: '/sy',
      name: 'sy',
      component: sy,
      children:[
      ]
    },
    {
      path: '/gg',
      name: 'gg',
      component: gg
    },
    {
      path: '/gw',
      name: 'gw',
      component: gw
    },
    {
      path: '/gdgg',
      name: 'gdgg',
      component: gdgg
    },
    {
      path: '/zhmm',
      name: 'zhmm',
      component: zhmm
    },
    
    zkzw,
    grzx,
    wdjl,
    wtjd
  ]
}



export default router





// WEBPACK FOOTER //
// ./src/views/main/router.js